import { render, staticRenderFns } from "./imcNinos2a5A.vue?vue&type=template&id=18362736&scoped=true&"
import script from "./imcNinos2a5A.vue?vue&type=script&lang=js&"
export * from "./imcNinos2a5A.vue?vue&type=script&lang=js&"
import style0 from "./imcNinos2a5A.vue?vue&type=style&index=0&id=18362736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18362736",
  null
  
)

export default component.exports